import type { UUID } from '@/utils/uuid';

export const clientQueryKeys = {
  list: (tenantId?: UUID, includeRevoked?: boolean) =>
    ['clients', tenantId, includeRevoked ?? false] as const,
  listByTenant: (tenantId?: UUID) => ['clients', tenantId] as const,
  detail: (tenantId?: UUID, clientId?: UUID) =>
    ['client-detail', tenantId, clientId] as const,
  downloads: (tenantId?: UUID) => ['clients', 'downloads', tenantId] as const,
  presence: (tenantId?: UUID) => ['clients', 'presence', tenantId] as const,
  runningInvocations: (tenantId?: UUID) =>
    ['clients', 'running-invocations', tenantId] as const,
};

export const clientMutationKeys = {
  createClient: (tenantId?: UUID) => ['createClient', tenantId] as const,
  removeClient: (tenantId?: UUID) => ['removeClient', tenantId] as const,
  revokeClient: (tenantId?: UUID) => ['revokeClient', tenantId] as const,
  enableClient: (tenantId?: UUID) => ['enableClient', tenantId] as const,
  registerClient: (tenantId?: UUID) => ['registerClient', tenantId] as const,
  rotateClientSecret: (tenantId?: UUID) =>
    ['rotateClientSecret', tenantId] as const,
};
